import React, { useState, useEffect } from "react";
import "./histroy.css";
import Time from "./timeline";
import axios from "axios";
import BackToTopButton from "./backtotop";
import Footer from "../../Footer/Footer";
import Navbar from "../../Navbar/Navbar";
import SubNavbar from "../../Navbar/SubNavbar";

const History = () => {
  const [timelineData, setTimelineData] = useState([]);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/timeline/`)
      .then((response) => {
        setTimelineData(Array.isArray(response.data) ? response.data : response.data.results || []);
        // alert("success");
      })
      .catch((error) => {
        setLoadError(true);
        console.error("Error fetching timeline:", error);
      });
  }, []);

  const decades = [...new Set(timelineData.map(item => Math.floor(Number(item.Year) / 10) * 10).filter(Number.isFinite))].sort((a,b) => b-a);
  const scrollToDecade = (decade) => {
    const first = timelineData.filter(item => Number(item.Year) >= decade && Number(item.Year) < decade + 10).sort((a,b) => b.Year-a.Year)[0];
    if (first) document.getElementById("timeline-year-" + first.Year)?.scrollIntoView({ behavior:"smooth", block:"start" });
  };

  return (
    <>
      <Navbar />
      <SubNavbar />
      
      <div className="history-top_section">
        <div className="history-top-sec-cont">
          <div className="history-left-side">
            <div className="history-lsh1">History</div>
            <div className="history-lsh2">
          
              <div className="history-lsh21">of our </div> Org
            </div>
          </div>
          <div className="history-right-side">
            <p className="history-subheader">
              Established in November 1996, Lokarpan emerged as a beacon of hope
              for rural communities grappling with poverty and inequity.
            </p>
            <p className="history-subheader1">
              Under the guidance of Shri H.V. Singh, our organisation was born
              from the belief in empowering communities to become architects of
              their own progress. This ethos formed the bedrock of our mission:
              to organise and empower the rural poor, fostering development as a
              catalyst for social justice, economic growth, and self-reliance.
             
            </p>
          </div>
        </div>
      </div>
      <div className="history-section-container">
        {/* ------------------------- */}
<div className="his-sec-text"> Over two decades, Lokarpan has developed a comprehensive strategy
              rooted in community engagement, forging sustainable solutions to
              the diverse challenges confronting rural India. Through our
              strategic partnerships, we've built a robust network of
              change-makers, amplifying our impact and driving inclusive
              development. With a team of sector-specialist trainers, locally
              trained staff, and grassroots infrastructure, Lokarpan remains
              steadfast in its commitment to a brighter, more equitable future
              for all.</div>
        {/* -------------------- */}
        {loadError ? <p role="alert" className="history-timeline-state">Timeline could not be loaded. Please refresh to try again.</p> : null}
        {!loadError && timelineData.length === 0 ? <p className="history-timeline-state">No timeline entries are available yet.</p> : null}
        {decades.length > 0 && <nav id="history-decade-navigation" className="history-decade-nav" aria-label="Jump to a decade">
          <span>Jump to decade</span>
          <div className="history-decade-options">{decades.map(decade => <button key={decade} type="button" onClick={() => scrollToDecade(decade)}>{decade}s</button>)}</div>
        </nav>}
        <Time data={timelineData} />

        <BackToTopButton />
      </div>
      <Footer />
    </>
  );
};

export default History;
